module.exports = __webpack_public_path__ + "img/linkedin_circle-512.6976c96a.png";